import React from "react";
import DealListing from "../DealsList/DealListing";

const DealSearchResult = (props) => {
  const { hit } = props;
  return <DealListing deal={hit} size="medium" />;
};

export default DealSearchResult;
